import { Controller } from "@hotwired/stimulus"

// Opens the newsletter pop-up after a short delay, once per version of its content.
// Dismissing it stores only a flag in localStorage (no cookie, no server record).
export default class extends Controller {
  static values = { delay: Number, key: String }

  connect() {
    if (this.dismissed()) return
    this.timer = setTimeout(() => this.open(), this.delayValue * 1000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  open() {
    if (this.element.open) return
    this.element.showModal()
    // Put the cursor in the email field, so the visitor can type straight away.
    this.element.querySelector('input[type="email"]')?.focus()
  }

  close() {
    this.remember()
    this.element.close()
  }

  // A click on the backdrop (outside the box) closes it, like the product dialog.
  backdrop(event) {
    if (event.target !== this.element) return
    const rect = this.element.getBoundingClientRect()
    const outside = event.clientX < rect.left || event.clientX > rect.right ||
                    event.clientY < rect.top || event.clientY > rect.bottom
    if (outside) this.close()
  }

  dismissed() {
    try {
      return window.localStorage.getItem(this.keyValue) === "1"
    } catch (error) {
      return false
    }
  }

  remember() {
    try {
      window.localStorage.setItem(this.keyValue, "1")
    } catch (error) {
      // Storage can be blocked: the pop-up may show again, which is harmless.
    }
  }
}
